import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';

import { PRINTER_KINDS } from 'pages/views/devices/types';

const useGetPrinter = (kind: PRINTER_KINDS) => {
  const printer = useSelector(state => state.hub.defaultPrinters[kind]);
  const isPrinterConnected = !isEmpty(printer);

  return {
    printer,
    isPrinterConnected,
  };
};

export { useGetPrinter };
